import {Component, OnInit, ViewChild}    from '@angular/core';
import {MapViewStore}                      from '../../../stores/layout/mapview.store';
import {ApLabResultFilesOverviewComponent} from './ap-lab-result-files-overview.component';
import {ApLogfileFilesOverviewComponent}   from './ap-logfile-files-overview.component';
import {ImportOverviewTabs}              from '../../types/ap-import-overview.types';

/**
 * Component for the import overview
 */
@Component({
  selector: 'ap-import-overview',
  templateUrl: 'ap-import-overview.component.html'
})
export class ApImportOverviewComponent implements OnInit {
  @ViewChild(ApLabResultFilesOverviewComponent, {static: false})
  public labsFilesOverviewComponent: ApLabResultFilesOverviewComponent;

  @ViewChild(ApLogfileFilesOverviewComponent, {static: false})
  public logfileFilesOverviewComponent: ApLogfileFilesOverviewComponent;

  public selectedTab: ImportOverviewTabs = ImportOverviewTabs.LabFilesTab;

  constructor(private mapViewStore: MapViewStore) {
  }

  public ngOnInit(): void {
    this.mapViewStore.hideMapView();
  }

  public searchIn(value: string): void {
    switch (this.selectedTab) {
      case ImportOverviewTabs.LabFilesTab:
        this.labsFilesOverviewComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case ImportOverviewTabs.LogfileFilesTab:
        this.logfileFilesOverviewComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }

  public selectTab(e: any): void {
    switch (this.selectedTab) {
      case ImportOverviewTabs.LabFilesTab:
        this.labsFilesOverviewComponent.dynComponent?.dynGrid.filterGrid('');
        break;
      case ImportOverviewTabs.LogfileFilesTab:
        this.logfileFilesOverviewComponent.dynComponent?.dynGrid.filterGrid('');
        break;
    }
    this.selectedTab = e.index as ImportOverviewTabs;
  }
}
